/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Subscribe_RefusedInputs */

const th_push_subscribe_refused = /** @type {(inputs: Push_Subscribe_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เบราว์เซอร์นี้ปฏิเสธการสร้างการสมัครรับการแจ้งเตือน บน macOS มักหมายความว่าต้องขอจากแอปที่ติดตั้งไว้ ไม่ใช่จาก Safari — ดูรายละเอียดข้อผิดพลาดได้ในคอนโซล`)
};

const en_push_subscribe_refused = /** @type {(inputs: Push_Subscribe_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This browser refused to create a push subscription. On macOS this usually means the installed app, not Safari, has to be the one asking — the console has the exact error.`)
};

const ja_push_subscribe_refused = /** @type {(inputs: Push_Subscribe_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このブラウザがプッシュ購読の作成を拒否しました。macOSでは通常、Safariではなくインストール済みのアプリから要求する必要があります。詳細なエラーはコンソールにあります。`)
};

const zh_push_subscribe_refused = /** @type {(inputs: Push_Subscribe_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此浏览器拒绝了推送订阅。在 macOS 上，这通常意味着必须由已安装的应用发起请求，而不是 Safari——控制台里有确切的错误。`)
};

const es_push_subscribe_refused = /** @type {(inputs: Push_Subscribe_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este navegador se ha negado a crear una suscripción push. En macOS esto suele significar que quien debe pedirlo es la aplicación instalada, no Safari; la consola tiene el error exacto.`)
};

const pt_push_subscribe_refused = /** @type {(inputs: Push_Subscribe_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este navegador recusou criar uma inscrição push. No macOS isso normalmente significa que quem precisa pedir é o aplicativo instalado, não o Safari — o console tem o erro exato.`)
};

const id_push_subscribe_refused = /** @type {(inputs: Push_Subscribe_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peramban ini menolak langganan push. Di macOS itu biasanya berarti aplikasi terpasanglah yang harus meminta, bukan Safari — konsol memuat kesalahan persisnya.`)
};

const fr_push_subscribe_refused = /** @type {(inputs: Push_Subscribe_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce navigateur a refusé de créer un abonnement push. Sur macOS cela signifie en général que c’est l’application installée, et non Safari, qui doit le demander — la console a l’erreur exacte.`)
};

const tl_push_subscribe_refused = /** @type {(inputs: Push_Subscribe_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tinanggihan ng browser na ito ang isang push subscription. Sa macOS, kadalasan ay nangangahulugan iyong ang naka-install na app ang dapat humiling, hindi ang Safari — nasa console ang eksaktong error.`)
};

const vi_push_subscribe_refused = /** @type {(inputs: Push_Subscribe_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trình duyệt này từ chối đăng ký nhận đẩy. Trên macOS điều đó thường có nghĩa ứng dụng đã cài mới được hỏi, chứ không phải Safari — bảng điều khiển ghi lỗi chính xác.`)
};

const ko_push_subscribe_refused = /** @type {(inputs: Push_Subscribe_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 브라우저가 푸시 구독을 거부했습니다. macOS에서는 대개 Safari가 아니라 설치된 앱이 요청해야 한다는 뜻이며, 콘솔에 정확한 오류가 있습니다.`)
};

const de_push_subscribe_refused = /** @type {(inputs: Push_Subscribe_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Browser hat ein Push-Abonnement abgelehnt. Unter macOS heißt das meistens, dass die installierte App fragen muss und nicht Safari — in der Konsole steht der genaue Fehler.`)
};

const ru_push_subscribe_refused = /** @type {(inputs: Push_Subscribe_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот браузер отказал в push-подписке. В macOS это обычно значит, что запрашивать должно установленное приложение, а не Safari — точная ошибка есть в консоли.`)
};

const tr_push_subscribe_refused = /** @type {(inputs: Push_Subscribe_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu tarayıcı anlık bildirim aboneliğini reddetti. macOS'ta bu genelde isteğin Safari'den değil yüklü uygulamadan gelmesi gerektiği anlamına gelir — tam hata konsolda.`)
};

const it_push_subscribe_refused = /** @type {(inputs: Push_Subscribe_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo browser ha rifiutato un'iscrizione push. Su macOS di solito significa che la richiesta deve partire dall'app installata e non da Safari: l'errore esatto è nella console.`)
};

const pl_push_subscribe_refused = /** @type {(inputs: Push_Subscribe_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta przeglądarka odrzuciła subskrypcję push. W macOS zwykle oznacza to, że pytać musi zainstalowana aplikacja, a nie Safari — dokładny błąd jest w konsoli.`)
};

const uk_push_subscribe_refused = /** @type {(inputs: Push_Subscribe_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цей браузер відхилив push-підписку. У macOS це зазвичай означає, що запитувати має встановлений застосунок, а не Safari — точна помилка є в консолі.`)
};

const hi_push_subscribe_refused = /** @type {(inputs: Push_Subscribe_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस ब्राउज़र ने पुश सदस्यता अस्वीकार कर दी। macOS पर इसका अर्थ आमतौर पर यह होता है कि अनुरोध इंस्टॉल किए ऐप से आना चाहिए, Safari से नहीं — सटीक त्रुटि कंसोल में है।`)
};

const ar_push_subscribe_refused = /** @type {(inputs: Push_Subscribe_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رفض هذا المتصفح اشتراك الإشعارات. على macOS يعني ذلك عادةً أن الطلب يجب أن يأتي من التطبيق المثبَّت لا من Safari — والخطأ الدقيق في الطرفية.`)
};

const ms_push_subscribe_refused = /** @type {(inputs: Push_Subscribe_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelayar ini menolak langganan tolakan. Pada macOS itu biasanya bermakna aplikasi yang dipasang perlu meminta, bukan Safari — ralat tepatnya ada dalam konsol.`)
};

const bn_push_subscribe_refused = /** @type {(inputs: Push_Subscribe_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই ব্রাউজার পুশ সাবস্ক্রিপশন প্রত্যাখ্যান করেছে। macOS-এ এর অর্থ সাধারণত ইনস্টল করা অ্যাপকেই চাইতে হবে, Safari-কে নয় — সঠিক ত্রুটি কনসোলে আছে।`)
};

const zh_tw2_push_subscribe_refused = /** @type {(inputs: Push_Subscribe_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個瀏覽器拒絕了推播訂閱。在 macOS 上，這通常表示必須由已安裝的應用程式提出要求，而不是 Safari——主控台中有確切的錯誤。`)
};

const zh_hk2_push_subscribe_refused = /** @type {(inputs: Push_Subscribe_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個瀏覽器拒絕了推播訂閱。在 macOS 上，這通常表示必須由已安裝的應用程式提出要求，而不是 Safari——控制台中有確切的錯誤。`)
};

const ur_push_subscribe_refused = /** @type {(inputs: Push_Subscribe_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اس براؤزر نے پُش سبسکرپشن سے انکار کیا۔ macOS پر اس کا مطلب عموماً یہ ہوتا ہے کہ درخواست انسٹال شدہ ایپ سے آنی چاہیے، Safari سے نہیں — درست خرابی کنسول میں ہے۔`)
};

const fa_push_subscribe_refused = /** @type {(inputs: Push_Subscribe_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`این مرورگر اشتراک اعلان فوری را رد کرد. در macOS معمولاً یعنی درخواست باید از برنامهٔ نصب‌شده بیاید نه از Safari — خطای دقیق در کنسول است.`)
};

const sw_push_subscribe_refused = /** @type {(inputs: Push_Subscribe_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kivinjari hiki kimekataa usajili wa arifa. Kwenye macOS hilo mara nyingi lina maana kwamba programu iliyosakinishwa ndiyo inapaswa kuomba, si Safari — hitilafu kamili ipo kwenye konsoli.`)
};

const nl_push_subscribe_refused = /** @type {(inputs: Push_Subscribe_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze browser heeft een pushabonnement geweigerd. Op macOS betekent dat meestal dat de geïnstalleerde app het moet vragen en niet Safari — de precieze fout staat in de console.`)
};

/**
* | output |
* | --- |
* | "This browser refused to create a push subscription. On macOS this usually means the installed app, not Safari, has to be the one asking — the console has the..." |
*
* @param {Push_Subscribe_RefusedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_subscribe_refused = /** @type {((inputs?: Push_Subscribe_RefusedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Subscribe_RefusedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_push_subscribe_refused(inputs)
	if (locale === "ja") return ja_push_subscribe_refused(inputs)
	if (locale === "zh") return zh_push_subscribe_refused(inputs)
	if (locale === "es") return es_push_subscribe_refused(inputs)
	if (locale === "pt") return pt_push_subscribe_refused(inputs)
	if (locale === "id") return id_push_subscribe_refused(inputs)
	if (locale === "fr") return fr_push_subscribe_refused(inputs)
	if (locale === "tl") return tl_push_subscribe_refused(inputs)
	if (locale === "vi") return vi_push_subscribe_refused(inputs)
	if (locale === "ko") return ko_push_subscribe_refused(inputs)
	if (locale === "de") return de_push_subscribe_refused(inputs)
	if (locale === "ru") return ru_push_subscribe_refused(inputs)
	if (locale === "tr") return tr_push_subscribe_refused(inputs)
	if (locale === "it") return it_push_subscribe_refused(inputs)
	if (locale === "pl") return pl_push_subscribe_refused(inputs)
	if (locale === "uk") return uk_push_subscribe_refused(inputs)
	if (locale === "hi") return hi_push_subscribe_refused(inputs)
	if (locale === "ar") return ar_push_subscribe_refused(inputs)
	if (locale === "ms") return ms_push_subscribe_refused(inputs)
	if (locale === "bn") return bn_push_subscribe_refused(inputs)
	if (locale === "zh-TW") return zh_tw2_push_subscribe_refused(inputs)
	if (locale === "zh-HK") return zh_hk2_push_subscribe_refused(inputs)
	if (locale === "ur") return ur_push_subscribe_refused(inputs)
	if (locale === "fa") return fa_push_subscribe_refused(inputs)
	if (locale === "sw") return sw_push_subscribe_refused(inputs)
	if (locale === "nl") return nl_push_subscribe_refused(inputs)
	return en_push_subscribe_refused(inputs)
});